import { useEffect } from 'react';
import { trackEvent } from '../utils/analytics';

export const useAnalyticsTracker = (componentName) => {
  // Track component mount
  useEffect(() => {
    trackEvent('Component', 'View', componentName);
    
    return () => {
      trackEvent('Component', 'Exit', componentName);
    };
  }, [componentName]);

  // Return tracking functions
  return {
    trackClick: (element, details = '') => 
      trackEvent('Interaction', 'Click', `${componentName} - ${element}`, details),
    
    trackSubmit: (formName, status = 'Start') => 
      trackEvent('Form', status, `${componentName} - ${formName}`),
    
    trackError: (action, error) => 
      trackEvent('Error', action, `${componentName} - ${error}`),
    
    trackAction: (category, action, label = '', value = null) => 
      trackEvent(category, action, label, value)
  };
}; 